import { render, staticRenderFns } from "./SystemIndex.vue?vue&type=template&id=93c1bd24&scoped=true"
import script from "./SystemIndex.vue?vue&type=script&lang=js"
export * from "./SystemIndex.vue?vue&type=script&lang=js"
import style0 from "./SystemIndex.vue?vue&type=style&index=0&id=93c1bd24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93c1bd24",
  null
  
)

export default component.exports